export const TAB_PATHS = {
    $1099_FORMS: "1099forms",
    STATE_PAYROLL_FORMS: "statepayrollforms",
};

export const REVIEW_REJECTED_LOADING_STATES = {
    REVIEW_REJECTED_PAGE_LOADING: "REVIEW_REJECTED_PAGE_LOADING",
    REVIEW_REJECTED_PAGE_READY: "REVIEW_REJECTED_PAGE_READY",
    STATES_LIST_LOADING: "STATES_LIST_LOADING",
    STATES_LIST_READY: "STATES_LIST_READY",
    FORMS_LIST_LOADING: "FORMS_LIST_LOADING",
    FORMS_LIST_READY: "FORMS_LIST_READY",
    TAXYEARS_LIST_LOADING: "TAXYEARS_LIST_LOADING",
    TAXYEARS_LIST_READY: "TAXYEARS_LIST_READY",
    PAYERS_LIST_LOADING: "PAYERS_LIST_LOADING",
    PAYERS_LIST_READY: "PAYERS_LIST_READY",
    DELETE_MODAL_LOADING: "DELETE_MODAL_LOADING",
    DELETE_MODAL_READY: "DELETE_MODAL_READY",
    RESUBMIT_FORMS_LOADING: "RESUBMIT_FORMS_LOADING",
    RESUBMIT_FORMS_READY: "RESUBMIT_FORMS_READY",
    FETCHING_VIEW_PDF_LIST_LOADING: "FETCHING_VIEW_PDF_LIST_LOADING",
    FETCHING_VIEW_PDF_LIST_READY: "FETCHING_VIEW_PDF_LIST_READY",
}

export const REVIEW_REJECTED_STATES_MESSAGE_MAP = {
    [REVIEW_REJECTED_LOADING_STATES.STATES_LIST_LOADING]: "",
    [REVIEW_REJECTED_LOADING_STATES.REVIEW_REJECTED_PAGE_LOADING]: "",
    [REVIEW_REJECTED_LOADING_STATES.FORMS_LIST_LOADING]: "",
    [REVIEW_REJECTED_LOADING_STATES.TAXYEARS_LIST_LOADING]: "",
    [REVIEW_REJECTED_LOADING_STATES.PAYERS_LIST_LOADING]: "",
    [REVIEW_REJECTED_LOADING_STATES.DELETE_MODAL_LOADING]: "",
    [REVIEW_REJECTED_LOADING_STATES.RESUBMIT_FORMS_LOADING]: "",
    [REVIEW_REJECTED_LOADING_STATES.FETCHING_VIEW_PDF_LIST_LOADING]: "",
}